
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/races/[race]",
      function () {
        return require("private-next-pages/races/[race].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/races/[race]"])
      });
    }
  